import classNames from 'classnames';
import ReactMarkdown from 'react-markdown';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import Styles from './Announcement.module.scss';
const Announcement = ({ header, content, createdOn, expanded }) => {
	return (
		<>
			{header != null && content != null ? (
				<div className={Styles.margin_bottom1}>
					<Accordion className={Styles.Accordion}>
						<AccordionSummary
							expandIcon={
								<ExpandMoreIcon
									className={Styles.color_white}
								/>
							}
							aria-controls='panel1bh-content'
							id='panel1bh-header'
							className={classNames(Styles.Bg_gradient)}
						>
							<div className={Styles.row}>
								<Typography>{header}</Typography>
								<Typography className={Styles.margin_1}>
									{createdOn}
								</Typography>
							</div>
						</AccordionSummary>
						<AccordionDetails>
							<div className={Styles.content_container}>
								<ReactMarkdown>{content}</ReactMarkdown>
							</div>
						</AccordionDetails>
					</Accordion>
				</div>
			) : null}
		</>
	);
};

export default Announcement;
